import React, { useEffect, useState } from 'react'

function SlideShow() {
    const [photoData, setPhotoData] = useState({ count: 0, images: [] });
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [currentIndex, setCurrentIndex] = useState(0);
    const [isVisable, setIsVisable] = useState(true);

    useEffect(() => {
        const imagesApiUrl = process.env.REACT_APP_API_URL;

        const fetchPhotos = async () => {
            try {
                const response = await fetch(imagesApiUrl);

                // console.log('Response status:', response.status);
                // console.log('Response ok:', response.ok);

                if (!response.ok) {
                    throw new Error('FAILED TO FETCH IMAGES');
                }

                const data = await response.json(); // JSON IS CREATED
                console.log(data);
                setPhotoData(data); // JSON IS SET TO STATE + DATA STORED HERE
                setLoading(false);
            } catch (err) {
                console.error('ERROR FETCHING PHOTOS:', err);
                setError(err.message);
                setLoading(false);
            }
        };

        fetchPhotos();
    }, []);

    useEffect(() => {
        if (photoData.count === 0) return;

        const interval = setInterval(() => {
            setIsVisable(false);

            setTimeout(() => {
                setCurrentIndex(prevIndex => {
                    const nextIndex = Math.floor(Math.random() * photoData.count);
                    return nextIndex === prevIndex ? (nextIndex + 1) % photoData.count : nextIndex;
                });
                setIsVisable(true);
            }, 500);
        }, 3000);

        return () => clearInterval(interval);
    }, [photoData.count]);

    return (
        <div id='box-photo'>
            {loading && <div className='loading-msg'>Loading photos...</div>}
            {error && <div className='error-msg'>Error: {error}</div>}
            {photoData.images[currentIndex] && (
                <img
                    src={photoData.images[currentIndex].url}
                    alt=''
                    // key={currentIndex}
                    // style={{ opacity: isVisable ? 1 : 0 }}
                />
            )}
        </div>
    );
};

export default SlideShow